<template>
  <b-row class="px-2">
    <b-col
      cols="12"
      class="px-25"
    >
      <hr class="border border-1" />
    </b-col>
    <b-col
      cols="4"
      lg="3"
      class="lg-mb-2 mb-1"
    >
      <h3 class="font-weight-bolder text-dark">Kas Masuk</h3>
      <hr
        class="mb-0"
        style="border-color: rgb(107 110 107)"
      />
    </b-col>
    <b-col
      cols="8"
      lg="9"
    ></b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label for="v-amount">Cash Awal</label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-amount"
            v-model="detailResultList.opening_cash"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-additional_cash"
          class="d-flex justify-content-between"
        >
          Cash Tambahan
          <span
            @click="openCashModal('isAdditionalCash')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-additional_cash"
            v-model="detailResultList.additional_cash"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-additional_cash"
          class="d-flex justify-content-between"
        >
          Penjualan Tunai
          <span
            @click="goToSellingDetail()"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-additional_cash"
            v-model="cashIn.order_success_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-piutang_amount"
          class="d-flex justify-content-between"
        >
          Pembayaran Piutang
          <span
            @click="openCashModal('isPiutangPayments')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-piutang_amount"
            v-model="cashIn.piutang_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-topup_deposit_amount"
          class="d-flex justify-content-between"
        >
          Topup Deposit
          <span
            @click="openCashModal('isTopupDeposit')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-topup_deposit_amount"
            v-model="cashIn.topup_deposit_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-cash_canceled"
          class="d-flex justify-content-between"
        >
          Retur Pembelian
          <span
            @click="openCashModal('isReturPurchasing')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-cash_canceled"
            v-model="cashIn.purchase_return_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col
      cols="4"
      lg="3"
      class="lg-mb-2 mb-1"
    >
      <h3 class="font-weight-bolder text-dark">Kas Keluar</h3>
      <hr
        class="mb-0"
        style="border-color: rgb(107 110 107)"
      />
    </b-col>
    <b-col
      cols="8"
      lg="9"
    ></b-col>

    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-cash_change"
          class="d-flex justify-content-between"
        >
          Kembalian Tunai
          <span
            @click="openCashModal('isCashChange')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-cash_change"
            v-model="cashOut.cash_change"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-cash_canceled"
          class="d-flex justify-content-between"
        >
          Transaksi Dibatalkan
          <span
            @click="openCashModal('isCanceledOrder')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-cash_canceled"
            v-model="cashOut.order_canceled_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-cash_canceled"
          class="d-flex justify-content-between"
        >
          Retur Penjualan
          <span
            @click="openCashModal('isReturSelling')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-cash_canceled"
            v-model="cashOut.order_return_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-utang"
          class="d-flex justify-content-between"
        >
          Pembayaran Utang
          <span
            @click="openCashModal('isUtangPayments')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-utang"
            v-model="cashOut.utang_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-other_payment_amount"
          class="d-flex justify-content-between"
        >
          Pembayaran Lainnya
          <span
            @click="goToCashOutDetail()"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-other_payment_amount"
            v-model="cashOut.other_payment_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-withdraw_deposit_amount"
          class="d-flex justify-content-between"
        >
          Withdraw Deposit
          <span
            @click="openCashModal('isWithdrawDeposit')"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-withdraw_deposit_amount"
            v-model="cashOut.withdraw_deposit_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-incoming_stock_warehouse_amount"
          class="d-flex justify-content-between"
        >
          Pembelian Stok Lokasi SKU
          <span
            @click="goToStockLocationSku()"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-incoming_stock_warehouse_amount"
            v-model="cashOut.incoming_stock_warehouse_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group class="custom__form--input">
        <label
          for="v-incoming_stock_supplier_amount"
          class="d-flex justify-content-between"
        >
          Pembelian Stok di Pemasok
          <span
            @click="goToStockSupplier()"
            class="text-primary cursor-pointer"
          >
            Lihat Detail
            <feather-icon
              size="12"
              class="text-primary fw-bold-800"
              icon="ArrowRightIcon"
            />
          </span>
        </label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-incoming_stock_supplier_amount"
            v-model="cashOut.incoming_stock_supplier_amount"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      class="px-25"
    >
      <b-form-group class="custom__form--input">
        <label for="v-closing_cash">Total Cash Akhir</label>
        <b-input-group prepend="Rp">
          <b-form-input
            id="v-closing_cash"
            v-model="formPayload.closing_cash"
            class="custom__input"
            type="text"
            disabled
          />
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col
      cols="12"
      class="px-25"
    >
      <hr class="border border-1" />
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton,
  BModal,
  BRow,
  BCol,
  BContainer,
  BTable,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BInputGroup,
  BIconTelephoneMinusFill,
  BLink,
} from 'bootstrap-vue';

export default {
  name: 'CashInCashOut',
  components: {
    BButton,
    BModal,
    BRow,
    BCol,
    BContainer,
    BTable,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BIconTelephoneMinusFill,
    BLink,
  },
  props: [
    'cashOut',
    'formPayload',
    'cashIn',
    'detailResultList',
    'openCashModal',
    'goToSellingDetail',
    'goToCashOutDetail',
    'goToStockLocationSku',
    'goToStockSupplier',
  ],
};
</script>
